export default "__VITE_ASSET__CPjzbrd3__"